<div class="sales-order-manage-presets">
  <h2 mat-dialog-title>
    Manage Presets

    <button
      mat-icon-button
      mat-dialog-close
      aria-label="Close dialog"
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <ng-container *ngIf="!isVisiblePresetForm">
      <div
        *ngIf="shippingPresets?.length; else empty"
        class="app-integration-preset-table"
      >
        <table class="lum-table lum-table--classic striped">
          <tr class="table__header-row">
            <th>Name</th>
            <th>Default</th>
            <th></th>
          </tr>
          <tbody>
            <tr *ngFor="let preset of shippingPresets; trackBy: trackById">
              <td>{{ preset?.name }}</td>
              <td>{{ preset?.isDefault ? 'Yes' : '' }}</td>
              <td class="text-end">
                <button type="button" mat-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onSetDefault(preset.id)">
                    <mat-icon>check</mat-icon>Set as default
                  </button>
                  <button mat-menu-item (click)="onUpdate(preset)">
                    <mat-icon>edit</mat-icon>Edit
                  </button>
                  <button mat-menu-item (click)="confirmDeleteAction(preset.id)">
                    <mat-icon>delete_outline</mat-icon>Delete
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #empty>
        <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
      </ng-template>

      <div class="flex justify-content-end mt-4">
        <button
          class="lum-button lum-button--primary"
          (click)="isVisiblePresetForm = !isVisiblePresetForm"
        >
          New Preset
        </button>
      </div>
    </ng-container>
    <lum-app-integration-preset-form
      *ngIf="isVisiblePresetForm"
      [selectedPreset]="selectedPreset"
      [appIntegrationAccountId]="data.appIntegrationAccountId"
      (cancel)="onCancel($event)"
    ></lum-app-integration-preset-form>
  </mat-dialog-content>
</div>
